import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Account } from '@/api/accounts';
import { payeesApi } from '@/api/payees';
import type { OwnerRegisterLine } from '@/api/transactions';
import type { NamePayeeResult } from './NamePayeeForm';

/**
 * Names the line's counterparty (`NamePayeeResult`), then hands the updated line to the host. The
 * one write behind `CounterpartyRow`'s dialog and the transaction drawer's in-place form.
 */
export function useNamePayeeOnLine(
  account: Account,
  line: OwnerRegisterLine,
  onChanged: (line: OwnerRegisterLine) => void | Promise<void>,
  onNotify: (message: string) => void,
) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  async function save(body: NamePayeeResult): Promise<boolean> {
    setBusy(true);
    try {
      const next = await payeesApi.nameOnLine(account.id, line.id, body);
      await onChanged(next);
      return true;
    } catch {
      onNotify(t('accounts.errorGeneric'));
      return false;
    } finally {
      setBusy(false);
    }
  }
  return { busy, save };
}
